/*
  AJAX add-to-cart for sections/pf-product-cards.liquid.

  Each card is a real <form action="/cart/add"> so it works without JS. Here
  we intercept the submit, POST to /cart/add.js, then read /cart.js and push
  the new item count into whatever cart-count elements the host theme
  renders in its header. A `pf:cart:added` event is dispatched with the
  cart so a cart drawer can hook in later without touching this file.
*/
(function () {
  'use strict';

  /* .cart-products-count is the Flexmart header badge (#CartCount / #CartCount_sticky); the rest cover common themes. */
  var COUNT_SELECTORS = '.cart-products-count, [data-cart-count], .cart-count, .cart_count, .cartCount, .cart-count-bubble, .header-cart .count, .cart .count, .cart-quantity';

  function setCount(count) {
    Array.prototype.forEach.call(document.querySelectorAll(COUNT_SELECTORS), function (el) {
      el.textContent = count;
    });
  }

  function announce(form, text) {
    var live = form.closest('section') && form.closest('section').querySelector('[data-pf-cart-status]');
    if (live) live.textContent = text;
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form.matches('form[data-pf-add]') || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var label = form.querySelector('[data-pf-add-label]');
    var original = label ? label.textContent : '';
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch(form.action + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: form.id.value, quantity: parseInt(form.quantity.value, 10) || 1 })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (label) label.textContent = 'Added ✓';
        announce(form, 'Added to cart. ' + cart.item_count + ' items in cart.');
        document.dispatchEvent(new CustomEvent('pf:cart:added', { detail: { cart: cart, form: form } }));
        setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 1600);
      })
      .catch(function () {
        if (label) label.textContent = original;
        btn.disabled = false;
        /* Fall back to the non-AJAX path so the customer still gets to the cart. */
        form.submit();
      });
  }

  document.addEventListener('submit', onSubmit);
})();
